import { defineMessages, useIntl } from 'react-intl'
import styles from './List.module.scss'
import classNames from 'classnames'

export interface ListProps {
  children: React.ReactNode
  className?: string
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}

export const List = ({ children, className, onMouseEnter, onMouseLeave, ...restProps }: ListProps) => {
  const intl = useIntl()

  const translations = defineMessages({
    label: {
      id: 'MobileHeader.list.ariaLabel',
      defaultMessage: 'List of homes and actions for Homebot - add home, buying report, etc.'
    }
  })

  return (
    <ul
      role='tablist'
      aria-label={intl.formatMessage(translations.label)}
      className={classNames(styles.list, className)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...restProps}
    >
      {children}
    </ul>
  )
}
